// Flora Materials: product page helpers, loaded by sections/main-product.liquid.
// theme.js is compiled and has no money formatter, so a Shopify-standard one lives here.

const formatMoney = (cents, format = window.themeVariables?.settings?.moneyFormat || '${{amount}}') => {
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;

  const formatWithDelimiters = (value, precision, thousands = ',', decimal = '.') => {
    const [whole, fraction] = (value / 100).toFixed(precision).split('.');
    return whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (fraction ? decimal + fraction : '');
  };

  const formatters = {
    amount: () => formatWithDelimiters(cents, 2),
    amount_no_decimals: () => formatWithDelimiters(cents, 0),
    amount_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
    amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 0, '.', ','),
    amount_with_apostrophe_separator: () => formatWithDelimiters(cents, 2, "'", '.'),
    amount_no_decimals_with_space_separator: () => formatWithDelimiters(cents, 0, ' '),
    amount_with_space_separator: () => formatWithDelimiters(cents, 2, ' ', ','),
    amount_with_period_and_space_separator: () => formatWithDelimiters(cents, 2, ' ', '.')
  };

  const key = format.match(placeholder)?.[1];
  return format.replace(placeholder, (formatters[key] || formatters.amount)());
};

// Renders price x quantity next to the quantity selector (quantity_selector block, "Show total price").
// The block is re-rendered on variant change with the new price in the `price` attribute (in cents).
class ProductTotalPrice extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    const onQuantityChange = (event) => {
      if (event.target === this.quantityInput) {
        this.update();
      }
    };

    document.addEventListener('input', onQuantityChange, { signal: this._abortController.signal });
    document.addEventListener('change', onQuantityChange, { signal: this._abortController.signal });

    // After a variant change the theme restores the previous quantity just after inserting the new block,
    // so read it on the next frame.
    requestAnimationFrame(() => this.update());
  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  get quantityInput() {
    return document.querySelector(`input[name="quantity"][form="${this.getAttribute('form')}"]`);
  }

  update() {
    const unitPrice = parseInt(this.getAttribute('price'), 10) || 0;
    const quantity = Math.max(parseInt(this.quantityInput?.value, 10) || 1, 1);
    this.querySelector('.product-total-price__amount').innerHTML = formatMoney(unitPrice * quantity);
  }
}

if (!window.customElements.get('product-total-price')) {
  window.customElements.define('product-total-price', ProductTotalPrice);
}
